export default __webpack_public_path__ + "static/media/icon_shoes.c3c53bfd.png";